module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 col-sm-12 footer-badge"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-12"
  }, [_c('div', {
    ref: "htb_badge_target",
    attrs: {
      "id": "htb_badge_target"
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 col-sm-12"
  }, [_c('a', {
    attrs: {
      "href": "https://tryhackme.com/"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://tryhackme-badges.s3.amazonaws.com/FoobarBeer.png",
      "alt": "TryHackMe"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b0e2e00"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/FooterBadge.vue
// module id = 1830
// module chunks = 1